var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      maxWidth: "680",
      title: _vm.$t("label_essweb_shift_form_dialog_newSiteTitle"),
      dialog: _vm.show,
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label: "label_essweb_shift_form_siteNameLabel",
                            items: _vm.SiteList,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "site_name",
                            "item-value": "uuid",
                          },
                          model: {
                            value: _vm.curSiteuuid,
                            callback: function ($$v) {
                              _vm.curSiteuuid = $$v
                            },
                            expression: "curSiteuuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.newProperty, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }